import { Link } from "react-router-dom";
import Hero1 from "../../assets/Hero1.svg";
import Hero2 from "../../assets/Hero2.svg";

export function Hero() {
  return (
    <div className="relative bg-gradient-to-b from-[#294BA1]/10 to-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute transform -rotate-45 -translate-x-1/2 -translate-y-1/2">
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="h-48 w-48 border border-[#294BA1]/20 rounded-full"
              style={{
                left: `${i * 100}px`,
                top: `${i * 100}px`,
              }}
            />
          ))}
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-center md:text-right space-y-8">
            <h1 className="text-4xl md:text-6xl font-bold text-[#294BA1] leading-tight">
              حجوزاتي
              <span className="block text-2xl md:text-3xl mt-4 text-gray-600 font-normal">
                خدمات النقل والحجز بين يديك
              </span>
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto md:mx-0">
              نقدم لك تجربة سفر متكاملة مع أفضل خدمات الحجز والنقل. سهولة وأمان
              وراحة بال
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Link
                to="/ourservices"
                className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#294BA1] hover:bg-[#294BA1]/90 transition-colors duration-300"
              >
                خدماتنا
              </Link>
              <Link
                to="/contactUs"
                className="inline-flex items-center justify-center px-8 py-3 border-2 border-[#294BA1] text-base font-medium rounded-md text-[#294BA1] hover:bg-[#294BA1]/5 transition-colors duration-300"
              >
                تواصل معنا
              </Link>
            </div>
          </div>

          {/* Image/Illustration */}
          <div className="relative  md:block">
            <div className="relative z-10 bg-white rounded-2xl p-6 shadow-lg">
              <div className="aspect-[4/3] relative overflow-hidden rounded-xl">
                <img
                  src={Hero1}
                  alt="خدمات النقل والحجز"
                  className="object-cover w-full h-full"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src =
                      "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=2069&auto=format&fit=crop";
                  }}
                />
              </div>
              {/* Stats */}
              <div className="grid grid-cols-3 gap-4 mt-6">
                {[
                  { value: "1000+", label: "عميل" },
                  { value: "24/7", label: "دعم متواصل" },
                  { value: "100%", label: "رضا العملاء" },
                ].map((stat, index) => (
                  <div
                    key={index}
                    className="text-center p-3 bg-[#294BA1]/5 rounded-lg"
                  >
                    <div className="text-xl font-bold text-[#294BA1]">
                      {stat.value}
                    </div>
                    <div className="text-sm text-gray-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
